import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateRiskCalculatorMutation = (
	creditReviewId: string,
	refetchRiskExposureCalculatorInfo: Function,
	refetchEstimatedExposureInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({ formValues }: { [key: string]: any }) => {
			return creditReviewDetailsService.updateRiskExposureCalculator(
				creditReviewId,
				formValues,
			);
		},

		{
			onSuccess() {
				refetchRiskExposureCalculatorInfo();
				refetchEstimatedExposureInfo();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateRiskCalculatorMutation;
